import { c as _c } from "react/compiler-runtime";
// SVG icons exported from Figma, shaped to behave like MUI icons:
// width/height = 1em (sized by font-size, e.g. text-[32px])
// fill = currentColor (colored by text-[...] classes)

export function HexBadge(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.99996 30.666V19.6994L3.66663 12.666L9.83329 2.66602H22.1666L28.3333 12.666L24 19.6994V30.666L16 27.9993L7.99996 30.666ZM10.6666 26.966L16 25.1993L21.3333 26.966V22.666H10.6666V26.966ZM11.3333 5.33268L6.79996 12.666L11.3333 19.9993H20.6666L25.2 12.666L20.6666 5.33268H11.3333ZM14.6 18.0993L9.86663 13.3993L11.7666 11.4993L14.6 14.3327L20.2333 8.66602L22.1333 10.5327L14.6 18.0993Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg viewBox="0 0 32 32" width="1em" height="1em" fill="currentColor" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function LoadedTrolley(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.33329 22.6667V6.66667H2.66663V4H7.99996V20H28V22.6667H5.33329ZM7.99996 29.3333C7.26663 29.3333 6.63885 29.0722 6.11663 28.55C5.5944 28.0278 5.33329 27.4 5.33329 26.6667C5.33329 25.9333 5.5944 25.3056 6.11663 24.7833C6.63885 24.2611 7.26663 24 7.99996 24C8.73329 24 9.36107 24.2611 9.88329 24.7833C10.4055 25.3056 10.6666 25.9333 10.6666 26.6667C10.6666 27.4 10.4055 28.0278 9.88329 28.55C9.36107 29.0722 8.73329 29.3333 7.99996 29.3333ZM9.33329 18.6667V10.6667H17.3333V18.6667H9.33329ZM12 16H14.6666V13.3333H12V16ZM18.6666 18.6667V10.6667H26.6666V18.6667H18.6666ZM21.3333 16H24V13.3333H21.3333V16ZM23.45 28.55C22.9277 28.0278 22.6666 27.4 22.6666 26.6667C22.6666 25.9333 22.9277 25.3056 23.45 24.7833C23.9722 24.2611 24.6 24 25.3333 24C26.0666 24 26.6944 24.2611 27.2166 24.7833C27.7388 25.3056 28 25.9333 28 26.6667C28 27.4 27.7388 28.0278 27.2166 28.55C26.6944 29.0722 26.0666 29.3333 25.3333 29.3333C24.6 29.3333 23.9722 29.0722 23.45 28.55Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg viewBox="0 0 32 32" width="1em" height="1em" fill="currentColor" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}